import { Link } from '@tanstack/react-router'
import { PREVIEW_APP_URL, GITHUB_REPO_URL } from '@/lib/constants'

export function Footer() {
  return (
    <footer className="border-t border-black/10 bg-gray-50 dark:border-white/10 dark:bg-[#0A0A0B]">
      <div className="mx-auto max-w-[1152px] px-6 py-12">
        <div className="flex flex-col items-center justify-between gap-8 md:flex-row">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center gap-2 md:items-start">
            <span className="font-mono text-lg font-semibold text-gray-900 dark:text-white">
              Garmisch
            </span>
            <p className="text-sm text-gray-500 dark:text-white/50">
              © 2025 Garmisch — Open Source Flutter Design System
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
            <Link
              to="/"
              className="text-sm text-gray-500 transition-colors hover:text-gray-900 dark:text-white/60 dark:hover:text-white"
            >
              Home
            </Link>
            <a
              href={PREVIEW_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-500 transition-colors hover:text-gray-900 dark:text-white/60 dark:hover:text-white"
            >
              Components
            </a>
            <a
              href={GITHUB_REPO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-500 transition-colors hover:text-gray-900 dark:text-white/60 dark:hover:text-white"
            >
              GitHub
            </a>
            <Link
              to="/privacy"
              className="text-sm text-gray-500 transition-colors hover:text-gray-900 dark:text-white/60 dark:hover:text-white"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-gray-500 transition-colors hover:text-gray-900 dark:text-white/60 dark:hover:text-white"
            >
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
